/* tslint:disable */
/**
 * This file is autogenerated using @sharefiledev/solution-view-engine-tools.
 *
 * Run 'sve typegen <relative path to manifest file>'
 *
 * Types are generated according to specification in a file that conforms to the UI Manifest schema:
 * https://us-solutionviewengine.sharefiletest.io/ui-manifest-v2.json
 */
import type {
	PiletApi,
	PiralCustomExtensionSlotMap as ShellPiralCustomExtensionSlotMap,
} from '@sharefiledev/sharefile-appshell';
import type { BlockParams } from '@sharefiledev/solution-view-engine';

export interface ShellProps {
	piletApi: PiletApi;
}
/** Block parameters for urn:sfblock:todos:provider */

export interface ProviderBlockParams {
	/**
	 * The resource identifier of the container to check for tasks
	 */
	containerRID: string;
}
/** Zone parameters for urn:sfzone:todos:provider:children */

export interface ProviderChildrenZoneParams {}
/** Contract Data for urn:sfzone:todos:provider:children */

export interface ProviderChildrenContractData {
	/**
	 * Whether the container has any tasks
	 */
	hasTaskCount?: boolean;
}
/** Block parameters for urn:sfblock:todos:list */

export interface ListBlockParams {
	/**
	 * The resource identifier of the container containing the todos
	 */
	containerRID: string;
	/**
	 * Whether the todos should be displayed in read-only mode
	 */
	readonly?: boolean;
}

export namespace BlockNames {
	export const Provider = 'urn:sfblock:todos:provider' as const;
	export type Provider = 'urn:sfblock:todos:provider';
	export const List = 'urn:sfblock:todos:list' as const;
	export type List = 'urn:sfblock:todos:list';
}

export namespace ZoneTypes {
	export const ProviderChildren = 'urn:sfzone:todos:provider:children' as const;
	export type ProviderChildren = 'urn:sfzone:todos:provider:children';
}

export type ProviderProps = ShellProps & BlockParams & ProviderBlockParams;
export type ListProps = ShellProps & BlockParams & ListBlockParams;

declare module '@sharefiledev/sharefile-appshell' {
	interface PiralCustomExtensionSlotMap {
		['urn:sfblock:todos:provider']: BlockParams & ProviderBlockParams;
		['urn:sfblock:todos:list']: BlockParams & ListBlockParams;
	}
}

declare module '@sharefiledev/solution-view-engine' {
	interface BlockCustomExtensionSlotMap extends ShellPiralCustomExtensionSlotMap {}

	interface PiletExtensionApi extends PiletApi {}

	interface ViewEngineCustomZoneParametersMap {
		['urn:sfzone:todos:provider:children']: ProviderChildrenZoneParams;
	}

	interface ViewEngineCustomZoneContractDataMap {
		['urn:sfzone:todos:provider:children']: ProviderChildrenContractData;
	}
}
